const data = {
	tips: [
		{
			tipHeading: "Tip #92",
			text: "Indulge in the island's famous sugar cake dessert",
			contentful_id: "123",
		},
		{
			tipHeading: "Tip #170",
			text:
				"Learn all about the island's history with pirates, including famous Captain Horatio Nelson",
			contentful_id: "456",
		},
		{
			tipHeading: "Tip #159",
			text: "Enjoy some of the best kite surfing and kite boarding conditions around",
			contentful_id: "789",
		},
	],
	articles: [
		{
			title: "Resort restaraunts with spectacular views",
			image: "https://picsum.photos/286/167",
			url: "/en",
			contentful_id: "101",
		},
		{
			title: "4 incredible swim-out-suites",
			image: "https://picsum.photos/286/167",
			url: "/en",
			contentful_id: "121",
		},
		{
			title: "Breathtaking beaches you need to see in your lifetime",
			image: "https://picsum.photos/286/167",
			url: "/en",
			contentful_id: "141",
		},
	],
};

export default data;
